<template>
  <div class="bravado-accordion">
    <div class="bravado-accordion__header">
      <div class="bravado-accordion__title">{{ title }}</div>
    </div>
    <div
      v-for="(item, index) in items"
      :key="index"
      :class="{ 'bravado-accordion__section': true, 'bravado-accordion__section--expanded': !!expanded[index] }"
    >
      <div class="bravado-accordion__item" @click="handleToggle(index)">
        <div class="bravado-accordion__label">{{ item.label }}</div>
        <ChevronDownIcon class="bravado-accordion__icon" />
      </div>
      <div class="bravado-accordion__description">
        {{ item.description }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import ChevronDownIcon from '@/assets/svg/chevron-down-rounded.vue.svg';

export default {
  name: 'BravadoAccordion',
  components: {
    ChevronDownIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const expanded = this.items.reduce(
      (acct, item, index) => (item.expanded ? Object.assign(acct, { [index]: true }) : acct),
      {},
    );

    return {
      expanded,
    };
  },
  methods: {
    handleToggle(index) {
      Vue.set(this.expanded, index, !this.expanded[index]);
    },
  },
};
</script>

<style scoped lang="scss">
.bravado-accordion {
  $this: &;

  border-radius: 8px;
  overflow: hidden;
  box-shadow: var(--theme-elevation-01);

  &__header {
    padding: 8px;
    background: var(--theme-color-over-card);
  }

  &__title {
    text-align: center;
    font-weight: 600;
    font-size: 13px;
    line-height: 1.54;
    color: var(--theme-color-sub-text);
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    background: var(--theme-color-card);
    cursor: pointer;
  }

  &__label {
    font-size: 13px;
    line-height: 1.54;
    color: var(--theme-color-sub-text);
    flex: 1;
    padding-right: 16px;
  }

  &__icon {
    color: var(--theme-color-sub-text);
    transform: rotate(0deg);
    transition: transform 0.1s linear;
  }

  &__description {
    display: none;
    height: 0;
    border-top: 1px solid var(--theme-color-border);
    padding: 0 12px;
    opacity: 0;
    background: var(--theme-color-over-card);
    font-size: 13px;
    line-height: 1.54;
    color: var(--theme-color-sub-text);
    transition: 0.1s;
  }

  &__section {
    border-top: 1px solid var(--theme-color-border);

    &--expanded {
      #{$this}__icon {
        transform: rotate(180deg);
        transition: transform 0.1s linear;
      }

      #{$this}__description {
        display: block;
        height: auto;
        padding: 8px 12px;
        opacity: 1;
      }
    }
  }
}
</style>
